angular.module('shop').component('buyProductBtn', {
	templateUrl: 'component/buy-product-btn.html',
	bindings: {
		product: '<'
	},
	controller: function($rootScope, ShopService) {
		var self = this;

		self.$onInit = function() {
			self.amount = ShopService.getCartAmount(self.product);
			self.displayItem = self.product.shopType && self.product.shopType === 'Butik_Visa_Endast';
		};

		this.addToCart = function(e) {
			e.stopPropagation();

			if (self.amount >= self.product.numberLeft) return;

			ShopService.addToCart(self.product);
		};

		this.increaseAmount = function(e) {
			e.stopPropagation();

			if (self.amount >= self.product.numberLeft + self.product.numberCheckedOut) return;

			ShopService.addToCart(self.product);
		};

		this.decreaseAmount = function(e) {
			e.stopPropagation();

			ShopService.removeFromCart(self.product);

			$rootScope.$emit('product-amount.update', {id: self.product.shopArticleID, amount: self.amount});
		};

		// Update product amount on changes
		$rootScope.$on('product-amount.update', function(event, data) {	
			if (data.id === self.product.shopArticleID) {
				self.amount = data.amount;
			}
		});

		// Check amount on cart update
		$rootScope.$on('shop-cart.update', function() {
			self.amount = ShopService.getCartAmount(self.product);
		});
	}
});